export class Metrics {

  public allRequestCount: number;
  public waitingForCustomerRequestCount: number;
  public createdRequestCount: number;
  public inProgressRequestCount: number;
  public expediteRequestCount?: number;
  public feedbackCount?: number;
}
